import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFedexComponent } from './simple-icons-fedex.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFedexComponent ],
    exports:      [ SimpleIconsFedexComponent ],
    bootstrap:    []
})
export class SimpleIconsFedexModule {}
